import { Reveal } from "@/components/Reveal";
import { HelpCTA } from "@/components/HelpCTA";
import { Marquee } from "@/components/Marquee";
import { CHAPTERS, WHY } from "@/data/content";
import { Seo } from "@/components/Seo";

const About = () => (
  <div data-testid="about-page" className="pt-20">
    <Seo
      title="About Us — Sober Life Foundation, Ulhasnagar"
      description="Our mission, vision and core values. A compassionate alcohol & drug rehabilitation centre by Balkan Ji Bari Trust, serving both men and women in Ulhasnagar."
      path="/about"
    />
    {/* HERO */}
    <section className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16 md:pb-24">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-teal mb-6">About Sober Life Foundation</p>
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl text-maroon-deep leading-[0.98] max-w-4xl">
          Our mission to heal, restore and rebuild lives
        </h1>
        <p className="mt-8 max-w-2xl text-stone-600 text-lg leading-relaxed">
          A recovery initiative of Balkan Ji Bari Trust — dedicated to compassionate, ethical and holistic
          addiction recovery for both men and women. We believe recovery is not just about quitting addiction;
          it is about rebuilding lives with hope, dignity and lasting transformation.
        </p>
      </Reveal>
    </section>

    {/* IMAGE */}
    <section className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <div className="overflow-hidden rounded-t-[3rem] h-[45vh] md:h-[60vh]">
          <img
            src="https://customer-assets-jt897jd0.emergentagent.net/job_sobriety-journey-19/artifacts/3pv4ljr4_7.webp"
            alt="Sober Life Foundation centre in Ulhasnagar"
            className="w-full h-full object-cover"
          />
        </div>
      </Reveal>
    </section>

    {/* MANIFESTO CHAPTERS */}
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-36 space-y-20 md:space-y-28">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.no}>
          <div className="grid md:grid-cols-12 gap-6 md:gap-12 items-start border-t border-stone-200 pt-10">
            <div className="md:col-span-4">
              <span className="font-heading text-7xl md:text-8xl text-sunrise leading-none">{c.no}</span>
            </div>
            <div className="md:col-span-8">
              <h2 className="font-heading text-3xl md:text-5xl text-maroon-deep mb-5">{c.title}</h2>
              <p className="text-stone-600 text-lg leading-relaxed max-w-2xl">{c.body}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </section>

    <Marquee />

    {/* WHY */}
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal>
        <h2 className="font-heading text-4xl md:text-6xl text-maroon-deep mb-14 max-w-2xl leading-[1.05]">Why families trust us</h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-8">
        {WHY.map((w, i) => (
          <Reveal key={w.title} delay={i * 0.1}>
            <div data-testid={`why-card-${i}`} className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-stone-100 h-full transition-shadow duration-300 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
              <span className="block h-10 w-10 rounded-full bg-teal/10 mb-6" />
              <h3 className="font-heading text-2xl text-maroon-deep mb-3">{w.title}</h3>
              <p className="text-stone-600 leading-relaxed">{w.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <HelpCTA />
  </div>
);

export default About;
